import React from "react";
import { Typography } from "@material-ui/core";



function TextByInstance(){



    const urlBool = window.config.config_keycloak.realm.includes("rdconnect") || window.config.config_keycloak.realm.includes("erdera")

    const textEGA =  <div style={{marginTop:"1%", marginBottom: "3%"}}>
    <Typography variant="h6">The IGV-Browser (igv.js) hosted by the Genome-Phenome Analysis Platform (GPAP) accesses alignments served
        by the <a href={"https://ega-archive.org/"}>European Genome-phenome Archive (EGA)</a> through its htsget server.
    </Typography>
    <Typography variant="body1">Please, select an Experiment ID and a genomic location to visualise it in the IGV Browser.</Typography>
</div>

    const textGeneral =  <div style={{marginTop:"1%", marginBottom: "3%"}}>
    <Typography variant="h6">Welcome to the IGV-Browser (igv.js) hosted by the Genome-Phenome Analysis Platform (GPAP)</Typography>
</div>

    if(urlBool)
    {
        return textEGA;
    }
    else{
        return textGeneral;
    }

}

export default TextByInstance;